import React, { useEffect, useRef, useState } from "react";

import Head from "next/head";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter1.json";

export default function Chapter_1() {

  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Central Doctrine | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="The School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Dive test into the depths of astrology, tarot, and Theurgic practices with our comprehensive courses at the School of Our Divine Infinite Being. Enroll now to become a certified divination consultant."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=1"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=1"
        ></meta>
        <meta
          name="twitter:title"
          content="Central Doctrine | The School of Our Divine Infinite Being"
        ></meta>
        <meta
          name="twitter:description"
          content="Dive into the depths of astrology, tarot, and Theurgic practices with our comprehensive courses at the School of Our Divine Infinite Being. Enroll now to become a certified divination consultant."
        ></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=1" />
      </Head>

      <Common_html BlockData={BlockData} />
    </>
  );
}
